import { useContext } from 'react';
import { PaymentContext } from '@/components/context/PaymentContext/PaymentContext';

/**
 * Returns Payment info along with actions to adjust payment/subscription
 */
export const usePayment = () => {
  const context = useContext(PaymentContext);

  return context;
};
